export const FETCH_DOCUMENTS_IS_COMPLETE = 'FETCH_DOCUMENTS_IS_COMPLETE';

export const FETCH_DOCUMENTS_IS_PENDING = 'FETCH_DOCUMENTS_IS_PENDING';

export const FETCH_DOCUMENTS_IS_ERROR = 'FETCH_DOCUMENTS_IS_ERROR';

export const FETCH_DOWNLOAD_IS_COMPLETE = 'FETCH_DOWNLOAD_IS_COMPLETE';

export const FETCH_DOWNLOAD_IS_ERROR = 'FETCH_DOWNLOAD_IS_ERROR';

export const FETCH_DOWNLOAD_IS_PENDING = 'FETCH_DOWNLOAD_IS_PENDING';

export const SORT = 'SORT';
